import * as React from 'react';
import Nodataimage from '../assets/nodata.svg';

export default function BasicModal() {

  return (
    <div style={{textAlign:"center"}}>
     
  <img src={Nodataimage} width="35%" style={{marginTop:"5%"}} />
<p>No Data Found</p>

    </div>
  );
}
